import { Metamodel } from '../base/model';
import { Activity, IAttribute, IModel, shellStringResources, ModelConstants, IViolation, ParameterValue, FabricSqlEndpointMetadataLinkedService} from 'shell-models-lib';
import { LinkedService } from '../linkedservice/linkedservice';
import { format } from '../../shared/utils/string.util';

@Metamodel.model({
    name: ModelConstants.refreshSqlEndpointActivity,
    referable: true
})
export class RefreshSqlEndpointActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly WORKSPACEID: IAttribute;
    public static readonly SQLENDPOINTID: IAttribute;
    public static readonly LINKED_SERVICE_PARAMETERS: IAttribute;
    public static readonly RECREATE_TABLES: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ConnectionLabel,
        constraint: {
            required: true,
            validator: RefreshSqlEndpointActivity.validateConnection
        },
        reference: true,
        type: FabricSqlEndpointMetadataLinkedService.MODEL
    })
    public fabricSqlEndpointMetadataLinkedService: FabricSqlEndpointMetadataLinkedService;

    @Metamodel.attribute({
        association: 'LINKED_SERVICE_PARAMETERS'
    })
    public linkedServiceParameters?: ParameterValue[] = [];

    // TODO anredd: Implement validators for these settings

    @Metamodel.attribute({
        display: shellStringResources.SqlEndpointIdLabel,
        association: 'SQLENDPOINTID',
        constraint: {
            validator: RefreshSqlEndpointActivity.validateSqlEndpoint
        },
        templatable: true,
        accepts: ['String']
    })
    public sqlEndpointId: string;

    @Metamodel.attribute({
        display: shellStringResources.TridentWorkspaceLabel,
        association: 'WORKSPACEID',
        constraint: {
            validator: RefreshSqlEndpointActivity.validateWorkspace
        },
        templatable: true,
        accepts: ['String']
    })
    public workspaceId: string;
  
    public static readonly TIMEOUT: IAttribute;

    @Metamodel.attribute({
        association: 'TIMEOUT',
        templatable: true,
        accepts: ['String']
    })
    public timeout?: string;

    @Metamodel.attribute({
        association: 'RECREATE_TABLES',
        templatable: true
    })
    public recreateTables?: boolean = false;

    private static validateSqlEndpoint(_refreshSqlEndpointActivity?: RefreshSqlEndpointActivity, value?: string): IViolation[] | undefined {
        if (!value) {
            return [
                {
                    message: () => format(shellStringResources.RequiredTemplate, shellStringResources.SqlEndpointLabel)
                }
            ];
        }
        return undefined;
    }

    private static validateWorkspace(_refreshSqlEndpointActivity?: RefreshSqlEndpointActivity, value?: string): IViolation[] | undefined {
        if (!value) {
            return [
                {
                    message: () => format(shellStringResources.RequiredTemplate, shellStringResources.TridentWorkspaceLabel)
                }
            ];
        }
        return undefined;
    }

    private static validateConnection(_refreshSqlEndpointActivity?: RefreshSqlEndpointActivity, linkedService?: LinkedService): IViolation[] | undefined {
        if (!linkedService) {
            return [
                {
                    message: () => format(shellStringResources.RequiredTemplate, shellStringResources.ConnectionLabel)
                }
            ];
        } else if (linkedService && linkedService.getLinkedServiceType() != Metamodel.modelFor(FabricSqlEndpointMetadataLinkedService).name) {
            return [
                {
                    message: () =>
                        format(
                            shellStringResources.ActivityNotSupportLinkedServiceError,
                            format(shellStringResources.ModelName_ActivityTemplate, shellStringResources.SqlEndpointLabel),
                            format(shellStringResources.ModelName_ConnectionTemplate, Metamodel.modelOf(linkedService).name)
                        ),
                    messageType: 'unsupported'
                }
            ];
        }
        return undefined;
    }
}